module.exports = __webpack_public_path__ + "img/1-2.ce03db8b.jpg";